import { createAsyncReducer } from 'redux-easy-async';

import * as Actions from '../legacy-financial-accounts/actions';

export default createAsyncReducer(
  // makes Actions into a real array instead of "array like"
  Object.keys(Actions).map((key) => Actions[key]),
);
